export default "__VITE_ASSET__BNZUzAWW__"